import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["href"]

import { IAttachment } from "@/interfaces/common/IAttachment";
import { PropType, computed, onMounted, onUpdated, ref } from "vue";
import Attachment from "./attachment.vue";
import utilities, {
  getComponentUiText,
  getPasswordDefaultVendorAttachment,
} from "@/utils/utilities";
import { fileSizeFormat } from "@/utils/dateTimeUtils";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import {
  CHECKLIST_TYPE,
  MODAL_NAME,
  TYPE_MODAL_SECURING_EVIDENCE,
  localStorageKey,
  successStatusCodes,
} from "@/utils/constants";
import { getAttachmentData } from "@/services/assessment";
import store from "@/store";
import { decryptText, decryptFileBase64 } from "@/utils/cipher";
import {
  getRequestAssessmentAttachment,
  getRequestVendorAssessmentAttachment,
} from "@/services/vendor";
import eventEmitter from "@/utils/eventEmitter";


export default /*#__PURE__*/_defineComponent({
  __name: 'attachments',
  props: {
  attachments: {
    type: Array as PropType<Array<IAttachment>>,
    default: () => [],
  },
  maxShown: {
    type: Number as PropType<number>,
    default: 3,
  },
  href: {
    type: String as PropType<string>,
    default: "#",
  },
  checklistItemId: {
    type: Number,
    default: 0,
  },
  passkeyQuestion: {
    type: String,
    default: "",
  },
  isHovered: {
    type: Boolean,
    default: false,
  },
  classNameAttachment: {
    type: String,
    default: "",
  },
  isVendorRequest: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    default: "",
  },
},
  emits: ["viewAttachments"],
  setup(__props, { emit }) {

const props = __props;




const loadings: any = ref([]);

const handleViewAttachments = (e: any) => {
  e.preventDefault();
  emit("viewAttachments");
};

const attachmentsData = ref(props.attachments);
const isCallApiGetImg = ref(false);
const providerId = computed(
  () => store.state.Vendor.checklistVendorRequestedExternalInput.providerId,
);

onMounted(() => {
  formatData();
});

const getAttachment = async (e: any, item, index) => {
  e.preventDefault();
  if (!props.passkeyQuestion) {
    emit("viewAttachments");
    if (props.isVendorRequest) {
      const check = await checkPasswordConfirm(
        item.attachmentId,
        getPasswordDefaultVendorAttachment(providerId.value),
      );
      if (check) {
        openAttachment(
          e,
          item,
          index,
          getPasswordDefaultVendorAttachment(providerId.value),
          check,
        );
        eventEmitter.emit(EmitterEvents.UPDATE_PASSWORD_ASSESSMENT_QUESTION, {
          checklistItemId: props.checklistItemId,
          password: getPasswordDefaultVendorAttachment(providerId.value),
        });
        return;
      }
    }
    openSecuringModal(e, item, index);
  } else {
    openAttachment(e, item, index);
  }
};

const checkPasswordConfirm = async (attachmentId, password) => {
  isCallApiGetImg.value = true;
  const res =
    props.isVendorRequest === CHECKLIST_TYPE.externalChecklist
      ? await store.dispatch(
          "Vendor/fetchVendorRequestedExternalAttachment",
          attachmentId,
        )
      : await store.dispatch(
          "Vendor/fetchVendorRequestedAttachment",
          attachmentId,
        );
  const file = await decryptFileBase64(res.data.data, password);
  isCallApiGetImg.value = false;
  return file ? res : false;
};

const openSecuringModal = (e: any, item, index) => {
  const emitData = {
    component: MODAL_NAME.MODAL_SECURING_EVIDENCE,
    properties: {
      type: TYPE_MODAL_SECURING_EVIDENCE.DECRYPT,
      checklistItemId: props.checklistItemId,
      isVendorRequest: props.isVendorRequest,
      attachmentId: item.attachmentId || item.id,
      styleClass: { background: "rgba(0, 0, 0, 0.5)", top: "0px" },
    },
    events: {
      "update:data": (password, data) => {
        openAttachment(e, item, index, password, data);
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const openAttachment = async (
  e: any,
  item,
  index: any,
  password?,
  dataFile?,
) => {
  e.preventDefault();
  try {
    if (isCallApiGetImg.value) return;
    loadings.value[index] = true;
    isCallApiGetImg.value = true;
    let res;
    if (dataFile) {
      res = dataFile;
    } else {
      if (props.isVendorRequest === CHECKLIST_TYPE.externalChecklist) {
        res = await store.dispatch(
          "Vendor/fetchVendorRequestedExternalAttachment",
          item.attachmentId || item.id,
        );
        emit("viewAttachments");
      } else {
        if (props.isVendorRequest === CHECKLIST_TYPE.reviewChecklist) {
          res = await store.dispatch(
            "Vendor/fetchVendorRequestedAttachment",
            item.attachmentId || item.id,
          );
          emit("viewAttachments");
        } else {
          res = await store.dispatch(
            "Assessment/getAttachment",
            item.attachmentId || item.id,
          );
        }
      }
    }
    if (res.status === successStatusCodes.OK) {
      const fileDecrypted = await handleDecryptFile(
        res.data.data,
        password ?? props.passkeyQuestion,
      );

      if (!fileDecrypted) {
        showError(
          getComponentUiText(
            "app-component-assessments-securing-evidence-modal-decrypt-error-1",
          ),
        );
        return;
      }

      if (!fileDecrypted?.fileType?.includes("image")) {
        downloadAttachment(item, password ?? props.passkeyQuestion);
      } else {
        const urlAttachment = `${fileDecrypted.file}`;
        EventEmitter.emit(EmitterEvents.OPEN_IMAGE_MODAL, { urlAttachment });
      }
    }
  } catch (error: any) {
    showError(error.data.error.message || "error");
  } finally {
    isCallApiGetImg.value = false;
    loadings.value[index] = false;
  }
};

const handleDecryptFile = async (file, passkeyQuestion) => {
  try {
    if (file) {
      const pwdFeIv = localStorage.getItem(localStorageKey.pwdFeIv) ?? "";
      const passkeyDecrypt = await decryptText(passkeyQuestion, pwdFeIv);
      const fileDecrypted = await decryptFileBase64(
        file,
        passkeyDecrypt ? passkeyDecrypt : passkeyQuestion,
      );

      if (fileDecrypted) {
        return fileDecrypted;
      } else {
        showError(
          "app-component-assessments-securing-evidence-modal-decrypt-error-1",
        );
      }
    }
  } catch (error: any) {
    showError(
      "app-component-assessments-securing-evidence-modal-decrypt-error-1",
    );
  }
};

const downloadAttachment = async (item, password) => {
  try {
    let res;
    if (props.isVendorRequest === CHECKLIST_TYPE.externalChecklist) {
      res = await getRequestAssessmentAttachment(item.attachmentId || item.id);
    } else {
      if (props.isVendorRequest === CHECKLIST_TYPE.reviewChecklist) {
        res = await getRequestVendorAssessmentAttachment(
          item.attachmentId || item.id,
        );
      } else {
        res = await getAttachmentData(item.attachmentId || item.id);
      }
    }

    if (res.status === successStatusCodes.OK) {
      const fileDecrypted = await handleDecryptFile(
        res.data.data,
        password ?? props.passkeyQuestion,
      );

      utilities.downloadBase64File(
        fileDecrypted.fileName,
        fileDecrypted.file,
        fileDecrypted.fileMimeTypeDetected,
      );
      showToastSuccess(
        getComponentUiText(
          "app-component-assessment-modal-assessment-toast-download-1",
        ),
      );
    }
  } catch (error: any) {
    showError(error?.message);
  }
};

const showToastSuccess = (message) => {
  const emitData: IToastMessage = { variant: ToastVariant.SUCCESS, message };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const showError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

onUpdated(() => {
  attachmentsData.value = props.attachments;
  formatData();
});

const formatData = () => {
  attachmentsData.value.map((attachment) => {
    attachment.name = attachment.fileNameOriginal || attachment.name;
    attachment.size = attachment.fileSizeBytes || attachment.size;
    return attachment;
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.id,
    class: "tw-flex tw-flex-col tw-justify-center tw-items-start tw-gap-[20px]"
  }, [
    (attachmentsData.value.length <= __props.maxShown)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([__props.classNameAttachment, "tw-w-full"])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...attachmentsData.value].splice(0, __props.maxShown), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "tw-flex tw-items-center tw-justify-between tw-relative"
            }, [
              _createVNode(Attachment, {
                title: item.name,
                size: `${_unref(fileSizeFormat)(item.size)}`,
                href: item.href || '#',
                "is-show-clock": !__props.passkeyQuestion && __props.isHovered,
                onClick: ($event: any) => (getAttachment($event, item, index))
              }, null, 8, ["title", "size", "href", "is-show-clock", "onClick"])
            ]))
          }), 128))
        ], 2))
      : _createCommentVNode("", true),
    (attachmentsData.value.length > __props.maxShown)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: __props.href,
          target: "_blank",
          class: "tw-text-[#387DFF] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[145%] tw-cursor-pointer !tw-no-underline",
          onClick: handleViewAttachments
        }, _toDisplayString(_unref(getComponentUiText)("app-component-attachments-view-attachments-1")), 9, _hoisted_2))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})